import { BAOCustomElement } from '@bao/custom-element'

class ButterflyMark extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.opened = false
  }

  setupListeners () {
    super.setupListeners()

    this.handleDrawerChange = this.handleDrawerChange.bind(this)
    document.addEventListener('drawer-changed', this.handleDrawerChange)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    document.removeEventListener('drawer-changed', this.handleDrawerChange)
  }

  handleDrawerChange () {
    if (window.drawers.activeDrawerKey !== 'butterfly-mark' || this.opened) { return }

    this.opened = true

    const iframe = document.createElement('iframe')
    iframe.id = 'pl-password-iframe-v1'
    iframe.src = `https://plpassport.stromdev.dk/?brand=${this.brandId}&s=widget`
    iframe.dataset.toggled = 'yes'
    iframe.style.height = '100%'
    iframe.style.width = '100%'

    this.els.body.element.insertAdjacentElement('afterbegin', iframe)
  }

  get brandId () {
    return this.dataset.brandId || ''
  }
}

if (!customElements.get('butterfly-mark')) {
  customElements.define('butterfly-mark', ButterflyMark)
}
